///
/// Vuex Module - Domain
///

import Vue from 'vue'
import { API } from '@/lib/api'
import * as types from '../types'
import { flatten } from '@/lib/utils'

/// STATE
const state = () => ({
	domain: {},
	domains: [],
})

/// ACTIONS
const actions = {
	async list({ commit }, params) {
		this.dispatch('misc/setLoading', true)

		let domains
		try {
			domains = await API.get(`/registrations/blacklist`, params)
			commit(types.SET_DOMAINS, domains)
			this.dispatch('misc/setLoading', false)
		} catch (error) {
			this.dispatch('misc/setError', error.message || error)
			this.dispatch('misc/setLoading', false)
			throw new Error(error.message || error)
		}

		return domains
	},
	async get({ commit }, domainId) {
		let domain
		try {
			domain = await API.get(`/registrations/blacklist/${domainId}`)
			console.log({ domain, })
			commit(types.SET_DOMAIN, domain)
		} catch (error) {
			this.dispatch('misc/setError', error.message || error)
			throw new Error(error.message || error)
		}

		return domain
	},
	async update({ commit }, { domainId, data }) {
		this.dispatch('misc/setLoading', true)

		let domain
		try {
			domain = await API.update(`/registrations/blacklist/${domainId}`, data)
			this.dispatch('misc/setLoading', false)
			commit(types.SET_DOMAIN, domain)
		} catch (error) {
			this.dispatch('misc/setError', error.message || error)
			this.dispatch('misc/setLoading', false)
			throw new Error(error.message || error)
		}

		return domain
	},
	async remove({ commit }, domainId) {
		try {
			await API.remove(`/registrations/blacklist/${domainId}`)
			commit(types.UNSET_DOMAIN)
		} catch (error) {
			this.dispatch('misc/setError', error.message || error)
			throw new Error(error.message || error)
		}
	},
	async create({ commit }, data) {
		this.dispatch('misc/setLoading', true)

		let domain
		try {
			domain = await API.send(`/registrations/blacklist`, data)
			this.dispatch('misc/setLoading', false)
			commit(types.SET_DOMAIN, domain)
		} catch (error) {
			this.dispatch('misc/setError', error.message || error)
			this.dispatch('misc/setLoading', false)
			throw new Error(error.message || error)
		}

		return domain
	},
	async unset({ commit}) {
		commit(types.UNSET_DOMAIN)
	},
}

/// MUTATIONS
const mutations = {
	[types.SET_DOMAINS](state, domains) {
		state.domains = domains
	},
	[types.SET_DOMAIN](state, domain) {
		state.domain = domain

		const idx = state.domains.findIndex(o => o.domainId == domain.domainId)
		if (idx > -1) {
			state.domains[idx] = domain
		} else {
			state.domains.push(domain)
		}

		console.log('STATE', state.domain)
		Vue.set(state, 'domains', [...state.domains])
	},
	[types.UNSET_DOMAIN](state) {
		state.domain = {}
	},
}

/// GETTERS
const getters = {
	domains: state => state.domains,
	domain: state => state.domain,
}

/// EXPORT
export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
}
